import { inventoryProductPrices } from 'utilities/api';
import { ListPriceUpdate } from './buildListPriceUpdates';

/** Cancellable axios result returned by the generated resource. */
export interface ApiResult<T> {
  promise: Promise<{ data: T }>;
  cancel: () => void;
}

/**
 * Typed view of the generated `products-prices` resource. `create` posts the
 * whole batch to `/v1/inventory/products-prices`, which upserts one record per
 * product id.
 */
export interface ListPriceApiResource {
  create: (body: ListPriceUpdate[]) => ApiResult<unknown>;
}

const listPriceApi = (inventoryProductPrices as unknown) as ListPriceApiResource;

export default listPriceApi;
